import React, {FC, useEffect, useState} from "react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import {domainUrl} from "../../../helper";
import NewPhotoSwipe from "../../ForCWV/InnerPageProduct/NewPhotoSwipe";

interface IProps {
    item: {
        customClassNames: string;
        convertedSettings: {
            styles: any
        };
        masonry: {
            images: Array<Record<string, string>>
            settings: {
                animation: string,
                desktopColumns: number,
                tabletColumns: number,
                mobileColumns: number,
                zoom: boolean,
                gap: number
            }
        }
    }
}

const MasonryComponent: FC<IProps> = ({item}) => {
    const {
        customClassNames,
        convertedSettings: {
            styles = {},
        } = {},
        masonry: {
            images = [{}],
            settings: {
                animation,
                desktopColumns,
                tabletColumns,
                mobileColumns,
                zoom,
                gap
            }
        }
    } = item;

    const [loadedCount, setLoadedCount] = useState(0);
    const allLoaded = loadedCount === images.length;

    useEffect(() => {
        setLoadedCount(0); // reset when images change
    }, [images]);

    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (isOpen) {
            const initializeGallery = async () => {
                const options = {
                    index: currentIndex,
                    bgOpacity: 0.9,
                    history: false
                };

                const items = images.map(({image_path}) => ({
                    src: image_path,
                    msrc: image_path,
                    w: 1000,
                    h: 1000,
                }));
                const { default: PhotoSwipe } = await import("photoswipe");
                const { default: PhotoSwipeUI_Default } = await import("photoswipe/dist/photoswipe-ui-default");

                const gallery = new PhotoSwipe(document.querySelector('.pswp') as HTMLElement, PhotoSwipeUI_Default, items, options);
                gallery.init();

                gallery.listen('beforeChange', () => {
                    const index = gallery.getCurrentIndex();
                    setCurrentIndex(index);
                });

                gallery.listen('close', () => {
                    setIsOpen(false);
                });

                return () => {
                    gallery.destroy();
                };
            }
            initializeGallery().then(r => r)
        }
    }, [isOpen, currentIndex]);

    const openGallery = (index: number) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    const handleImageClick = (index: number) => {
        if (zoom) openGallery(index);
        return;
    }

    return (
        <div data-aos={animation} className={customClassNames} style={{ margin: styles?.margin, padding: styles?.padding }}>
            {zoom && isOpen ? <NewPhotoSwipe/> : <></>}
            <ResponsiveMasonry
                columnsCountBreakPoints={{
                    425: mobileColumns,
                    600: tabletColumns,
                    991: desktopColumns
                }}
            >
                <Masonry gutter={`${gap}px`}>
                    {images.map(({id, image_path}, index) => (
                        <img
                            onClick={() => handleImageClick(index)}
                            key={id}
                            style={{
                                height: "unset !important",
                                width: "100%",
                                display: "block",
                                opacity: allLoaded ? 1 : 0, // hide until ready
                                transition: "opacity 0.3s ease-in-out",
                                cursor: zoom ? "pointer" : "default"
                            }}
                            alt="masonry image"
                            aria-hidden="true"
                            src={image_path}
                            onLoad={() => setLoadedCount((c) => c + 1)}
                        />
                    ))}
                </Masonry>
            </ResponsiveMasonry>
        </div>
    );
}

export default MasonryComponent;